import { BetaFeaturesEnum, GetBetaFeaturesResponse, } from '@src/api/beta-features/get-beta-features';

export function hasAirMaxEnabled(data: GetBetaFeaturesResponse[]) {
  if (data.length) {
    const airMaxEnabled = data.find(
      ([key]) => key === BetaFeaturesEnum.AIR_MAX,
    )?.[1];

    if (!airMaxEnabled) {
      window.location.replace(`${import.meta.env.VITE_BASE_URL}`);
    }
  } else {
    window.location.replace(`${import.meta.env.VITE_BASE_URL}/dashboard`);
  }
}
